import { useEffect, useState } from 'react';
import { MarkItViewApi } from '../../../../Apis/Apis';
import { MarketViewProductModel } from '../../../../Generated/Mark-It-View-Api';
import { StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import { StoneXButton, StoneXMultiselect } from '../../../StoneXMui';

export default function CacheManagement() {
  const [products, setProducts] = useState<MarketViewProductModel[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isClearingExpirationDates, setIsClearingExpirationDates] = useState(false);
  const [isClearingProducts, setIsClearingProducts] = useState(false);

  useEffect(() => {
    MarkItViewApi.listMarketViewProducts(null).then((res) => setProducts(res.data.rows ?? []));
  }, []);

  async function clearExpirationDates() {
    if (selectedProductIds.length === 0) return;
    setIsClearingExpirationDates(true);
    try {
      await MarkItViewApi.listMarketViewExpirationDates(
        null,
        selectedProductIds,
        true,
      );
    } finally {
      setIsClearingExpirationDates(false);
    }
  }

  async function clearProducts() {
    setIsClearingProducts(true);
    try {
      await MarkItViewApi.listMarketViewProducts(
        null,
        undefined, // all commodity types
        undefined,
        undefined,
        undefined,
        true, // refreshCache
      );
    } finally {
      setIsClearingProducts(false);
    }
  }

  return (
    <StoneXMainPage>
      <StoneXRow>
        <h3>Cache Management</h3>
      </StoneXRow>

      <StoneXRow>
        <h4>Expiration Dates</h4>
      </StoneXRow>
      <StoneXRow>
        <StoneXMultiselect
          list={products}
          label="Products"
          labelSelector={(p) => p.name}
          valueSelector={(p) => p.productId}
          resultSetter={setSelectedProductIds}
        />
        <StoneXButton
          variant="outlined"
          isWorking={isClearingExpirationDates}
          disabled={selectedProductIds.length === 0}
          onClick={clearExpirationDates}
        >
          Clear Expiration Dates
        </StoneXButton>
      </StoneXRow>

      <StoneXRow marginDirection="top">
        <h4>Products</h4>
      </StoneXRow>
      <StoneXRow>
        <StoneXButton
          variant="outlined"
          isWorking={isClearingProducts}
          onClick={clearProducts}
        >
          Clear Products
        </StoneXButton>
      </StoneXRow>
    </StoneXMainPage>
  );
}
